/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import o from"../Point.js";import{projectWithZConversion as r}from"../projection.js";import{projectVectorToPoint as t}from"./projectVectorToPoint.js";async function n(n,e,i,c){const s=t(n,e,i);if(null!=s)return s;const p=new o({x:n[0],y:n[1],z:n[2],spatialReference:e,hasZ:!0});return r(p,i,c)}export{n as projectVectorToPointWithEngine};
